import Image from "next/image"
import styles from "./course.module.css";
import Webbanner from "../../assets/images/Tnpsc/TNPSC-Gr1-Mains-Crash-Course-Web-Banner.jpg";
import Mobbanner from "../../assets/images/Tnpsc/TNPSC-Gr1-Mains-Crash-Course-Mobile-Banner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import hand from "../../assets/images/upsc/modalnew.png";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const TNPSC_Group_I_Mains_Crash_Course = () => {

    const feestructure3 =[
        {center: "AnnaNagar",mode: "Regular(Hybrid)", start: "16th October 2026",
                fee: (<><div>₹48,000 (New Students)</div> <div></div>₹45,000 (SIA Old Students) </>),
                // cont3:(<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2026/TNPSC-GroupI-Mains-Test Series-2026-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}> Click here</Link>),
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>)
            }
    ]

    return (
        <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index, follow" />.
            <meta name="robots" content="index, follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group I Mains Crash Course 2026</title>
            <meta name="title" content="TNPSC Group I Mains Crash Course 2026" />
            <meta name="description" content="Join TNPSC Group I Mains Crash Course 2026 at Shankar IAS Academy offers expert classes, answer writing, study materials, and full-length mock tests." />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-i-mains-crash-course/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group I Mains Crash Course 2026" />
            <meta property="og:description" content="Join TNPSC Group I Mains Crash Course 2026 at Shankar IAS Academy offers expert classes, answer writing, study materials, and full-length mock tests." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-i-mains-crash-course/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
                <div className="col-lg-8 col-12 pt-3 pt-md-3">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Group I Mains Crash Course 2026</h1>
                </div>
                {/* <div className="col-xl-4 pt-3 pt-md-5 text-xl-end text-center col-12">
                    <Link href="/tnpsc-group-i-mains-test-series" ><button className={`${styles.normalbutton2} mt-2 mt-md-0`} type="submit">Click Here for TNPSC Group I GS Mains Test Series </button></Link>
                </div> */}
            </div>

        <div className="row d-none d-md-block">
            <div className="col pt-2 mb-3">
                <Image src={Webbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
            </div>
            </div> 

            <div className="row  d-block d-md-none">
             <div className="col pt-2 mb-3">
                <Image src={Mobbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
            </div>
            </div>

            <div className="row pt-2">
                <div className="col-lg-8 col-12">
                    {/* <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC – Group I Mains Crash Course</h2> */}
                </div>
            </div>

        </div>
        
        <section  id="courseandfees " className={`${styles.courseandfees} pt-2 pt-md-2 pb-4 pb-md-5`}>
        <div className="container pt-xl-4" >
            <div className="row">
                    <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#a91414" }}>Center</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Mode</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#a91414" }}>Starts on</div>
                    <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Fee</div>
                    {/* <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Schedule</div> */}
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#a91414" }}>Payment</div>
                    <hr/>
            </div>
                    
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.center}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Mode</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2  pb-md-3`}>{item.mode}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2`}>{item.start}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.fee}</div>
                      {/* <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div> */}
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Payment</div>
                      <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
                        {item.pay}
                      </div>
                            <hr/>
                </div>
                    ))} 
                </div>
	</section> 


     <div
      className="container-fluid py-4 py-md-5"
      style={{ background: "linear-gradient(135deg, #f4f6f8, #eaf0f5)", }}
      >
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 col-xl-10">
          <div className={styles.featuresCard}>
            {/* Heading */}
            <div className="row">
              <div className="col-12">
                <h2 className={`${styles.sectionTitle} `}>
                 <span style={{color:"#061569"}}>Programme Highlights </span> 
                </h2>
              </div>
            </div>

            {/* Features */}
            <div className="row g-4 g-md-5">
              <div className="col-12 col-md-6">
                <ul className={styles.featureList}>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      <b>Duration: 3+ Months.</b> 
                    </span>
                  </li>
                 
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      The program is mostly suitable for first-time main-appearing students or beginners who do not learn or understand main subjects properly.
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                        The program is focused on, as per the Group-I main syllabus, all subjects like social issues, ethics, Tamil heritage, science and technology, and environment.
                        Except Polity, Geography, and Economy are only covered in the main parts of the syllabus)
                    </span>
                  </li>
                </ul>
              </div>

              {/* Right Column */}
              <div className="col-12 col-md-6">
                <ul className={styles.featureList}>

                   <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                      The Group-I main eligibility orientation class will be conducted.
                    </span>
                  </li>


                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                    The total number of main tests is 14, a closed-type test (9 unit tests, 3 full lengths, and 2 eligibility tests will be conducted, and no prior answer keys will be given).
                    </span>
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                     <b>To Revision Recorded videos are available for up to 30 days.</b>
                    </span>
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>
                    To Completed syllabus ,Extra class will be conducted, if required .

                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
           

    <Interest />
    <Footer />

        </>
    )
}

export default TNPSC_Group_I_Mains_Crash_Course
